import { render, staticRenderFns } from "./ItemDetailEntrySlideLayout.vue?vue&type=template&id=48560bb8&scoped=true"
import script from "./ItemDetailEntrySlideLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailEntrySlideLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48560bb8",
  null
  
)

export default component.exports